const NULL_TEXT = /^(null|undefined)$/i

/**
 * A delivery contact name as the form can hold it. Oracle and the Data
 * Platform return a missing name as null, and the delivery form rejects a null
 * name, which silently disables Place order (CLOS-14646). The text "null" is
 * left alone: it can be a real surname.
 */
export const cleanContactName = (value?: string | null): string =>
  typeof value === 'string' ? value.trim() : ''

/**
 * A delivery email or phone number. As above, and a draft saved earlier can
 * carry the text "null" or "undefined", which is not an email or a number and
 * would be shown on the delivery card.
 */
export const cleanContactField = (value?: string | null): string => {
  const text = cleanContactName(value)
  return NULL_TEXT.test(text) ? '' : text
}
